import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ImpersonationStateService } from '../../../security/services/impersonation-state.service';
import { ImpersonationService } from '../../../security/services/impersonation.service';
import { UserAuthorizationService } from '../../../security/services/user-authorization.service';

@Component({
    selector: 'app-impersonation-indicator',
    templateUrl: './impersonation-indicator.component.html',
    styleUrls: ['./impersonation-indicator.component.scss'],
})
export class ImpersonationIndicatorComponent implements OnInit {

    isLoggedIn: boolean = false;

    constructor(
        private router: Router,
        protected authService: UserAuthorizationService,
        private impersonationService: ImpersonationService,
        protected impersonationStateService: ImpersonationStateService
    ) { }

    ngOnInit() {
        this.authService.user$.subscribe(user => {
            this.impersonationService.updateActiveImpersonation();
            this.isLoggedIn = user != null;
        })
    }

    public endImpersonation() {
        this.router.navigate(['admin', 'impersonation', 'end']);
    }
}
